import { erpAxios } from '.';

const setGarancija = async (data) => {
  const res = await erpAxios.post(`/garancijaZahtjeva`, data);
  return res;
};

export default setGarancija;
